import { MutationTree } from 'vuex';
import { ArtistViewState } from '@/store/types/artistView.state';

export const mutations: MutationTree<ArtistViewState> = {
    setArtist(state, value){
        state.artist = value;
    },
    setArtistArtworks(state, value){
        state.artistArtworks = value;
    },
    setLoading(state, value){
        state.loading = value;
    },
    setDisplayingImageURL(state, value){
        state.displayingImage = value;
    },
    setDisplayingBigImage(state, value){
        state.displayingBigImage = value;
    },
    
};
